import { Directive, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ElasticSearchService } from '../shared/search-elasticsearch.service';
import { UtilsService } from '../shared/utils.service';
import { ContentService } from '../shared/content.service';

import { prebootComplete } from "angular2-universal";

@Directive({
  selector: '[content-records-featured]',
  exportAs: 'featured',
})
export class ContentRecordsFeaturedComponent implements OnInit {

  @Input() currentLanguage: string;
  public dbContents = [];

  constructor(private contentService: ContentService, private utils: UtilsService, private route: ActivatedRoute, private router: Router, private es: ElasticSearchService) {}

  ngOnInit(){
    this.contentService.getContentsByField('record','tags','featured')
      .then(res => {
        this.dbContents = res;
        // manual preboot in order to avoid the flickering when the client side view kicks in over the server view
        // we wait till the asyn data is available to do the replacement
        if (typeof prebootComplete != 'undefined') {
          prebootComplete();
        }
      });

  }

  dbContentsLimited(limit: number): any[] {
    let limited = [];
    for (var i = 0; i < this.dbContents.length; i++) {
      limited.push(this.dbContents[i]);
      if(i==limit-1)
        break;
    }
    return limited;
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/front/content-records-featured.component.ts